import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModal: FC<Props> = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation(["global"]);
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("deleteTitle")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
				{t("deleteDescription")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {t("cancel")}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
          }}
          color="error"
          variant="contained"
        >
          {t("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
